import store from '@/store'
import { RightsTypeMap } from '@/common/constant'
export default {
	// 是否是免登流程
	isExemption(state) {
		return state.is_exemption ? 1 : 0
	},
	// 下单当前选中权益券信息
	rightCouponInfo() {
		const { selectRightInfo, isTransfer } = store.state.train
		const { curTransferIndex } = store.getters.train
		const infoContainer = isTransfer ? selectRightInfo?.[0]?.union_all_price?.[curTransferIndex] || {} : selectRightInfo?.[0] || {}
		const { deduction_amount: amount = 0, discount_desc: desc = '', coupon_name: name = '' } = infoContainer
		return { amount, desc, name }
	},
	// 退改无忧权益券信息 
	worryFreeCouponInfo() {
		const worryfreeType = RightsTypeMap.worryfree
		const { selectSeatInfo, isTransfer } = store.state.train
		const { curTransferIndex } = store.getters.train
		const worryfreeRightInfo = selectSeatInfo?.[0]?.service_info?.serviceInfoList?.find(item => item?.type === worryfreeType) || {}
		const infoContainer = isTransfer ? worryfreeRightInfo.union_all_price?.[curTransferIndex] || {} : worryfreeRightInfo
		const { deduction_amount: amount = 0, discount_desc: desc = '', coupon_name: name = '' } = infoContainer
		return { amount, desc, name }
	},
	// 免登购票券信息
	offlineCouponInfo() {
		const { selectSeatInfo, isTransfer } = store.state.train
		const { curTransferIndex } = store.getters.train
		const offlineRightInfo = selectSeatInfo?.[0]?.service_info?.offlineService || {}
		const infoContainer = isTransfer ? offlineRightInfo.union_all_price?.[curTransferIndex] || {} : offlineRightInfo
		const { deduction_amount: amount = 0, discount_desc: desc = '', coupon_name: name = '' } = infoContainer
		return { amount, desc, name }
	}
}
